import Button from '@shared/components/core/button/CoreButton';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export interface IClientDeleteProps {
    organizationId: string;
    clientId: string;
}

export default function ClientDelete({ clientId, organizationId }: IClientDeleteProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [showWarning, setShowWarning] = useState(false);

    const handleCancelWarning = () => {
        setShowWarning(false);
    };

    const deleteClient = async () => {
        try {
            const result = await useOrganizationStore.getState().deleteOrgAuthClient(organizationId, clientId);
            if (result.resultType == 'Ok') {
                navigate(-1);
                useAlertsStore.getState().showError(t('common:organization.projects.key.delete.success'));
            }
        } catch (error) {
            useAlertsStore.getState().showError(t('common:organization.projects.key.delete.error'));
        }
    };
    return (
        <>
            <Button $color="accent" startIcon="cancel2" onClick={() => setShowWarning(true)}>
                {t('common:organization.projects.key.delete.title')}
            </Button>
            <ContentDialog
                open={showWarning}
                onCancel={handleCancelWarning}
                onClose={handleCancelWarning}
                onConfirm={deleteClient}
                confirmButtonText={t('common:organization.projects.key.delete.title')}
                title={t('common:organization.projects.key.delete.title')}
                description={t('common:organization.projects.key.delete.description')}
            />
        </>
    );
}
